// @flow
import React from 'react';
import {applyMiddleware, compose, createStore} from "redux";
import thunk from "redux-thunk";
import {Provider} from "react-redux";
import {BrowserRouter as Router, Redirect, Route, Switch} from "react-router-dom";
import combinedReducers from "./reducers/combinedReducers";
import QueryPage from "./containers/QueryPage";
import Bootstrap from "./containers/app/Bootstrap";
import ProfileProvider from "./containers/profile/ProfileProvider";
import PhotoEBadgeQueryPage from "./containers/ebadge/photo/PhotoEBadgeQueryPage";
import { BADGE_GROUP_CSV_JOB_PAGE_URL, BadgeGroupCsvJobContainer } from './containers/BadgeGroupCsvJobContainer';

export default function App() {
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    let store = createStore(combinedReducers, composeEnhancers(applyMiddleware(thunk)));

    return (
        <Provider store={store}>
            <Bootstrap>
                <ProfileProvider>
                    <Router>
                        <Switch>
                            <Redirect exact from="/" to="/query/ebadges"/>
                            <Route path={'/query'} component={QueryPage}/>
                            <Route path={'/photo/query'} component={PhotoEBadgeQueryPage}/>
                            <Route path={BADGE_GROUP_CSV_JOB_PAGE_URL} component={BadgeGroupCsvJobContainer} />
                        </Switch>
                    </Router>
                </ProfileProvider>
            </Bootstrap>
        </Provider>
    );
};



// WEBPACK FOOTER //
// ./src/App.js